import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Breadcrumb } from './Breadcrumb';
import { Heading } from './Heading';
import { Description } from './Description';
import { ProductGrid } from './ProductGrid';
/**
 * Gen 3 category page (/shop/gen-3/).
 *
 * Self-contained: every section lives in `./` and is owned by this page only.
 */
export function Gen3Page() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-585">
      <Header data-id="element-586" />
      <main className="flex-grow pt-32 pb-20" data-id="element-587">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-588">
          <Breadcrumb data-id="element-589" />
          <Heading data-id="element-590" />
          <Description data-id="element-591" />
          <ProductGrid data-id="element-592" />
        </div>
      </main>
      <Footer data-id="element-593" />
    </div>;
}